import React, {useEffect, useState} from 'react';
import SubSection from '../../libs/react-components-admin/section/sub-section';
import CloseModal from '../../libs/react-components-admin/modal/close-modal';
import {RowWithButtonConfig} from '../common/button-config';
import ColorField from '../../libs/react-components-admin/fields/color-field';
import {FloatField, IntegerField} from '../../libs/react-components-admin/fields/text-like-field';
import PaddingConfig from '../common/padding-config';

const OpenButtonConfig = ({idPrefix, label, value, onChange}) =>
  <button type="button"
          className="btn btn-sm btn-outline-dark"
          onClick={() => CloseModal.showModal(
            <RowWithButtonConfig idPrefix={idPrefix}
                                 value={value}
                                 onChange={v => onChange(v)}/>
          )}>
    {label}
  </button>;

const BackdropConfig = ({className, value, onChange}) => {

  const [model, setModel] = useState(value || {});
  useEffect(() => { onChange(model); }, [model]);

  return <SubSection title="Backdrop" className={className}>
    <div className="row">
      <div className="col-12 col-md-6">
        <ColorField id="popup-backdrop-color"
                    label="Color"
                    valueOnChoose="#000000"
                    value={model.color}
                    onChange={v => setModel({...model, color: v})}/>
      </div>
      <div className="col-12 col-md-6">
        <FloatField id="popup-backdrop-opacity"
                    label="Opacity"
                    helpBlock={<>Enter a value between 0 and 1 (1 being fully opaque)</>}
                    value={model.opacity}
                    onChange={v => setModel({...model, opacity: v})}/>
      </div>
    </div>
  </SubSection>;
};

const ContentConfig = ({className, value, onChange}) => {

  const [model, setModel] = useState(value || {});
  useEffect(() => { onChange(model); }, [model]);

  return <SubSection title="Content" className={className}>
    <PaddingConfig value={model.padding} onChange={v => setModel({...model, padding: v})}/>
  </SubSection>;
};

const CloseIconConfig = ({className, value, onChange}) => {

  const [model, setModel] = useState(value || {});
  useEffect(() => { onChange(model); }, [model]);

  return <SubSection title="Close icon" className={className}>
    <div className="row">
      <div className="col-12 col-md-6">
        <ColorField id="popup-close-icon-color"
                    label="Color"
                    valueOnChoose="#000000"
                    value={model.color}
                    onChange={v => setModel({...model, color: v})}/>
      </div>
      <div className="col-12 col-md-6">
        <IntegerField id="popup-close-icon-size"
                      label="Size (in pixels)"
                      value={model.size}
                      onChange={v => setModel({...model, size: v})}/>
      </div>
    </div>
  </SubSection>;
};

const PopupConfig = ({value, onChange}) => {

  const [model, setModel] = useState(value || {enabled: false});

  useEffect(() => {
    onChange(model.enabled ? model : {enabled: false});
  }, [model]);

  useEffect(() => {
    if ((value || {}).enabled != null && model.enabled !== value.enabled) {
      setModel({...model, enabled: value.enabled});
    }
  }, [(value || {}).enabled]);

  const title = <div className="form-check">
    <input type="checkbox"
           id="popup-config-enabled"
           className="form-check-input"
           style={{width: '0.8em', height: '0.8em', marginTop: '5px'}}
           checked={!!model.enabled}
           onChange={e => setModel({...model, enabled: e.target.checked})} />
    <label className="form-check-label" htmlFor="popup-config-enabled" style={{cursor: 'pointer'}}>
      Display the form in a pop-up
    </label>
  </div>;
  return <SubSection title={title}>
    {model.enabled &&
    <>
      <SubSection title="Buttons" className="mb-3" noMargin={true}>
        <div className="row">
          <div className="col-12 col-md-4 d-grid">
            <OpenButtonConfig idPrefix="popup-show-"
                              label="Open show button settings"
                              value={model.showButton}
                              onChange={v => setModel({...model, showButton: v})}/>
          </div>
          <div className="col-12 col-md-4 d-grid">
            <OpenButtonConfig idPrefix="popup-close-"
                              label="Open close button settings"
                              value={model.closeButton}
                              onChange={v => setModel({...model, closeButton: v})}/>
          </div>
          <div className="col-12 col-md-4 d-grid">
            <OpenButtonConfig idPrefix="popup-ok-"
                              label="Open OK button settings"
                              value={model.okButton}
                              onChange={v => setModel({...model, okButton: v})}/>
          </div>
        </div>
      </SubSection>
      <BackdropConfig value={model.backdrop}
                      onChange={v => setModel({...model, backdrop: v})}/>
      <ContentConfig value={model.content}
                     onChange={v => setModel({...model, content: v})}/>
      <CloseIconConfig value={model.closeIcon}
                       onChange={v => setModel({...model, closeIcon: v})}/>
    </>
    }
  </SubSection>;
};

export default PopupConfig;
